<template>
    <v-sheet>
        <!-- 추가질문답변 -->
        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">{{ index + 1 }}. {{ item?.question?.subject }} {{ item?.question?.isMultipleSelect ? "(복수선택 가능)" : "" }}</h5>
        <v-divider class="primary border-2" />
        <v-sheet class="pa-10 px-md-20 py-md-16">
            <template v-if="item?.question?.type == RECRUITMENT_QUESTION_TYPES.SHORT_ANSWER.value">
                <!-- <v-text-field v-model="item.response" v-bind="{ ...attrs_input, readonly }" @input="emit" /> -->
                <v-textarea v-model="item.response" no-resize rows="1" auto-grow v-bind="{ ...attrs_input, readonly }" class="like-text-field" @input="emit" />
            </template>
            <template v-else-if="item?.question?.type == RECRUITMENT_QUESTION_TYPES.DESCRIPTIVE.value">
                <v-textarea v-model="item.response" v-bind="{ ...attrs_input, readonly }" @input="emit" />
            </template>
            <template v-else-if="item?.question?.type == RECRUITMENT_QUESTION_TYPES.MULTIPLE_CHOICE.value">
                <v-row v-if="item.question.isMultipleSelect" no-gutters class="ma-0">
                    <v-col v-for="choice in item.question.choices" :key="choice" cols="auto" class="mr-20">
                        <v-checkbox v-model="item.response" multiple :value="choice" :label="choice" v-bind="{ readonly }" hide-details @change="emit" />
                    </v-col>
                </v-row>
                <v-radio-group v-else v-model="item.response" row hide-details>
                    <v-radio v-for="choice in item.question.choices" :key="choice" :label="choice" :value="choice" v-bind="{ readonly }" @change="emit" />
                </v-radio-group>
            </template>
        </v-sheet>
        <v-divider />
    </v-sheet>
</template>

<script>
import { attrs_input, RECRUITMENT_QUESTION_TYPES } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: () => ({}) },
        index: { type: Number },
        readonly: { type: Boolean, default: false },
    },
    data: () => ({
        item: {},

        attrs_input,
        RECRUITMENT_QUESTION_TYPES,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.item = { ...this.value };
        },
        emit() {
            this.$emit("input", this.item);
        },
    },
};
</script>

<style lang="scss" scoped>
.like-text-field {
    :deep(textarea) {
        min-height: 48px;
        margin-top: 0 !important;
        padding: 8px 12px 8px 0 !important;
        line-height: 32px;
    }
}
</style>
